import { memo } from 'react';
import PropTypes from 'prop-types';

import { SvgStringToHtml } from 'src/components/SvgStringToHtml';
import { GENERATION_TOOL, GENERATION_TOOL_CARD_NEW_DOCUMENT } from 'src/data/generationTool';
import { PROJECT_TYPE } from 'src/data/project';

import { getGenerationToolCardImage } from './utils';

export const GenerationToolCardImage = memo(
  ({ className, projectType, tool, svgStringImage, small }) => {
    if (svgStringImage) {
      return (
        <SvgStringToHtml
          className={className}
          svgString={svgStringImage}
        />
      );
    }

    const Icon = getGenerationToolCardImage({ projectType, tool }, { small });
    return <Icon className={className} />;
  }
);

GenerationToolCardImage.propTypes = {
  className: PropTypes.string,
  projectType: PropTypes.oneOf(Object.values(PROJECT_TYPE)),
  tool: PropTypes.oneOf([...Object.values(GENERATION_TOOL), GENERATION_TOOL_CARD_NEW_DOCUMENT])
    .isRequired,
  svgStringImage: PropTypes.string,
  small: PropTypes.bool,
};

GenerationToolCardImage.defaultProps = {
  className: null,
  projectType: PROJECT_TYPE.document,
  svgStringImage: null,
  small: false,
};
